export default "__VITE_ASSET__B1QFdAu0__"